import {
  LoadingOutlined,
} from "@ant-design/icons";
import {
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Spin,
} from "antd";
import { useForm } from "antd/es/form/Form";
import React from "react";
import { adminContext } from "../../Common/PageRoute";
import { Utils } from "../../Utilities/Utils";
import dayjs from "dayjs";
import UserService, { roleOption } from "../../Services/UserService";
import SAModal from "../../Common/Custom Components/Ant design/SAModal";

const AddUser = ({ onDismiss, practiceId, userId }: any) => {
  const [form] = useForm();
  const { openNotification } = React.useContext(adminContext);
  const [loading, setLoading] = React.useState(false);

  const val = {
    address: {
      country: "United Kingdom",
    },
  };

  // const [practiceIds, setPracticeIds] = React.useState([]);

  // React.useEffect(() => {
  //   // setLoading(true);
  //   PracticesService.getUserData()
  //     .then((rec) => {
  //       if (rec?.result && rec?.result.length > 0) {
  //         const practiceIds = rec?.result?.map((item: any) => item.id) || [];
  //         setPracticeIds(practiceIds);
  //       } else {
  //         openNotification("error", rec.message || `Can't get practices`);
  //       }
  //     })
  //     .catch((err) => {
  //       openNotification("error", err || `Can't get practices`);
  //     })
  //   // .finally(() => setLoading(false));
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // const practiceOptions = practiceIds?.map((ids: any) => ({
  //   label: `Practice ${ids}`,
  //   value: ids,
  // }));

  return (
    <SAModal
      open={true}
      width={700}
      //confirmLoading={loading}
      title={userId !== undefined ? `Edit user details` : "Add new user"}
      okText={"Save"}
      isLoading={loading}
      cancelText={"Cancel"}
      okButtonProps={{ disabled: loading }}
      cancelButtonProps={{ disabled: loading }}
      onCancel={() => onDismiss(false)}
      onOk={async () => {
        try {
          await form.validateFields(); // Validate form first
          setLoading(true);

          let userValues = {
            ...form.getFieldsValue(),
            birthDate: dayjs(
              form.getFieldValue("birthDate"),
              "DD/MM/YYYY"
            ).format("YYYY-MM-DD"), // Ensure correct date format
          };

          const res = await UserService.createNewUser(userValues);
          if (res.status) {
            onDismiss(true);
            openNotification(
              "success",
              `New user ${res?.result?.name?.first + " " + res?.result?.name?.last
              } successfully created.`
            );
          } else {
            openNotification("error", res.message);
          }
        } catch (error) {
          setLoading(false);
          //openNotification("error", "Validate Fields");
        } finally {
          setLoading(false);
        }
      }}
    >
      <Spin
        spinning={loading}
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <Form requiredMark={false} form={form} initialValues={val} >
          <Row className="pt-2 pb-1 font-semibold" justify="space-between">
            Profile information
          </Row>
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Title"
                name={["name", "title"]}
              // rules={[
              //   { required: true, message: "Title is required" },
              //   { validator: Utils.validateWhiteSpace },
              // ]}
              >
                <Select
                  disabled={false}
                  className="select-height-28"
                  placeholder="Title"
                  options={[
                    { value: "Mr", label: "Mr" },
                    { value: "Mrs", label: "Mrs" },
                    { value: "Miss", label: "Miss" },
                    { value: "Sir", label: "Sir" },
                    { value: "Ms", label: "Ms" },
                    { value: "Dr", label: "Dr" },
                    { value: "Prof", label: "Prof" },
                    { value: "Madam", label: "Madam" },
                    { value: "Ma'am", label: "Ma'am" },
                    { value: "Lord", label: "Lord" },
                    { value: "Lady", label: "Lady" },
                    { value: "Reverend", label: "Reverend" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="First name"
                name={["name", "first"]}
                rules={[
                  { required: true, message: "First name is required" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input
                  disabled={false}
                  className="line-height-28"
                  placeholder="First name"
                  onKeyPress={(e: any) => Utils.ValidateCharOnly(e)}
                  onInput={(e: any) =>
                  (e.target.value =
                    e.target.value.length > 1
                      ? e.target.value
                      : e.target.value.toUpperCase())
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Last name"
                name={["name", "last"]}
                rules={[
                  { required: true, message: "Last name is required" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              // requiredMark={false}
              >
                <Input
                  disabled={false}
                  className="line-height-28"
                  placeholder="Last name"
                  onKeyPress={(e: any) => Utils.ValidateCharOnly(e)}
                  onInput={(e: any) =>
                  (e.target.value =
                    e.target.value.length > 1
                      ? e.target.value
                      : e.target.value.toUpperCase())
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Gender"
                name="gender"
              // rules={[{ required: true, message: "Gender is required" }]}
              >
                <Select
                  disabled={false}
                  className="select-height-28"
                  placeholder="Gender"
                  options={[
                    // { value: 0, label: "Select" },
                    { value: 1, label: "Male" },
                    { value: 2, label: "Female" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Birth date"
                name="birthDate"
              // rules={[
              //   { required: true, message: "Birth date is required" },
              //   { validator: Utils.validateBirthdate },
              // ]}
              // getValueProps={((i:any)=>({ value: dayjs(i)}))}
              // getValueFromEvent={(onChange) => dayjs(onChange).format("DD/MM/YYYY")}
              >
                <DatePicker
                  disabled={false}
                  style={{ width: "100%", height: 28 }}
                  className="line-height-28"
                  placeholder="Birth date"
                  format="DD/MM/YYYY"
                //defaultValue={dayjs(userProfile?.birthDate, "DD/MM/YYYY")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Email is required" },
                  { validator: Utils.ValidateEmailFormat },
                ]}
              >
                <Input
                  disabled={false}
                  className="line-height-28"
                  placeholder="Email"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Phone number"
                name="phoneNumber"
              // rules={[
              //   { required: true, message: "Phone number is required" },
              //   {
              //     pattern: /^[0-9]{10}$/,
              //     message: "Mobile No. must be 10 digits",
              //   },
              // ]}
              >
                <Input
                  disabled={false}
                  className="line-height-28"
                  placeholder="Phone number"
                  onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                  maxLength={10}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Role"
                name="role"
                rules={[{ required: true, message: "Role is required" }]}
              >
                <Select
                  disabled={false}
                  className="select-height-28"
                  placeholder="Role"
                  options={roleOption}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* <Row className="pt-1"> */}
          {/* <Col span={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 22 }}
                label="Practices"
                name="practiceId"
                rules={[{ required: true, message: "Practice id is required" }]}
              >
                <Select
                  className="select-height-28"
                  disabled={false}
                  placeholder="Practices"
                  options={practiceOptions}
                />
              </Form.Item>
            </Col> */}
          {/* </Row> */}
          {/* <Row
            className="ps-1 pt-3 pb-1  font-semibold"
            justify="space-between"
          >
            Address information
          </Row>
          <Row className="px-3 pt-1">
            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 22 }}
                label="Building"
                name={["address", "building"]}
              >
                <Input
                  disabled={false}
                  className="line-height-28"
                  placeholder="Building"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 22 }}
                label="Street"
                name={["address", "street"]}
              >
                <Input
                  disabled={false}
                  className="line-height-28"
                  placeholder="Street"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="px-3 pt-1">
            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 22 }}
                label="City"
                name={["address", "city"]}
              >
                <Input
                  disabled={false}
                  className="line-height-28"
                  placeholder="City"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 22 }}
                label="County"
                name={["address", "county"]}
              >
                <Input
                  disabled={false}
                  className="line-height-28"
                  placeholder="County"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="px-3 pt-1">
            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 22 }}
                label="Country"
                name={["address", "country"]}
              >
                <Select
                  showSearch
                  disabled={false}
                  className="select-height-28"
                  placeholder="Country"
                  options={countriesOptions}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 22 }}
                label="Post code"
                name={["address", "postcode"]}
              >
                <Input
                  disabled={false}
                  className="line-height-28"
                  placeholder="Post code"
                />
              </Form.Item>
            </Col>
          </Row> */}
        </Form>
      </Spin>
    </SAModal>
  );
};

export default AddUser;
